import {
  waitForRender,
  captureElementAsImage,
  getShipmentAlarmSections,
} from "../pdfUtils";
import { drawAlarmSummary } from "../helpers/drawAlarmSummary";
import { drawShipmentSections } from "../helpers/drawShipmentSections";

export async function generateSimplifiedReportPages({
  pdf,
  chartRef,
  reportData,
  alerts,
  margin,
  pageHeight,
  maxWidth,
  onBeforeCapture,
}) {
  pdf.addPage();

  const alarmSections = await getShipmentAlarmSections(reportData);

  let y = drawShipmentSections(pdf, margin, alarmSections);
  y = drawAlarmSummary(pdf, alerts, y);

  await onBeforeCapture("full");
  try {
    await waitForRender();
  } catch (error) {
    console.error("Error en waitForRender para gráfica completa:", error);
  }

  const { imgData, imgWidth, imgHeight } = await captureElementAsImage(
    chartRef,
    maxWidth,
    pageHeight - y - margin
  );

  const yFullImg = y + 10;
  pdf.addImage(imgData, "JPEG", margin, yFullImg, imgWidth, imgHeight);
}
